// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as Heading1 from "../Heading1.bs.js";
import * as Year2014 from "./Year2014.bs.js";
import * as Year2016 from "./Year2016.bs.js";
import * as Year2018 from "./Year2018.bs.js";
import * as Year2020 from "./Year2020.bs.js";
import * as Year2024 from "./Year2024.bs.js";
import * as OneMillion from "./OneMillion.bs.js";
import * as FirstSmartCard from "./FirstSmartCard.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

var wrapper = Curry._1(BsCss.style, {
      hd: BsCss.media("(min-width: 1200px)", {
            hd: BsCss.marginLeft("auto"),
            tl: {
              hd: BsCss.marginRight("auto"),
              tl: {
                hd: BsCss.display("flex"),
                tl: {
                  hd: BsCss.overflowX("scroll"),
                  tl: {
                    hd: Css.unsafe("-ms-overflow-style", "none"),
                    tl: {
                      hd: Css.unsafe("scrollbar-width", "none"),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }),
      tl: /* [] */0
    });

var innerWrapper = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1406)),
      tl: {
        hd: BsCss.marginLeft("auto"),
        tl: {
          hd: BsCss.marginRight("auto"),
          tl: {
            hd: BsCss.marginBottom(BsCss.px(80)),
            tl: {
              hd: BsCss.position("relative"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var headingDiv = Curry._1(BsCss.style, {
      hd: BsCss.display("flex"),
      tl: {
        hd: BsCss.alignItems("center"),
        tl: {
          hd: BsCss.justifyContent("spaceBetween"),
          tl: {
            hd: BsCss.margin(BsCss.px(30)),
            tl: {
              hd: BsCss.media("(max-width: 768px)", {
                    hd: BsCss.marginLeft(BsCss.px(20)),
                    tl: {
                      hd: BsCss.marginRight(BsCss.px(20)),
                      tl: /* [] */0
                    }
                  }),
              tl: {
                hd: BsCss.media("(min-width: 1280px)", {
                      hd: BsCss.marginLeft("auto"),
                      tl: {
                        hd: BsCss.marginRight("auto"),
                        tl: {
                          hd: BsCss.maxWidth(BsCss.px(1200)),
                          tl: /* [] */0
                        }
                      }
                    }),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var headingText = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(40)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(50)),
        tl: {
          hd: BsCss.color(Theme.Color.charcoal),
          tl: {
            hd: BsCss.fontWeight("semiBold"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var swipeRightDiv = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(14)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(28)),
        tl: {
          hd: BsCss.letterSpacing(BsCss.px(2)),
          tl: {
            hd: BsCss.color(Theme.Color.prezzeeRed),
            tl: {
              hd: BsCss.media("(min-width: 1280px)", {
                    hd: BsCss.display("none"),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var aboutUsOurJourneyContainer = Curry._1(BsCss.style, {
      hd: BsCss.overflowX("scroll"),
      tl: {
        hd: Css.unsafe("-ms-overflow-style", "none"),
        tl: {
          hd: Css.unsafe("scrollbar-width", "none"),
          tl: /* [] */0
        }
      }
    });

var innerContainer = Curry._1(BsCss.style, {
      hd: BsCss.backgroundImage(BsCss.url("/images/about/journey/timeline.svg")),
      tl: {
        hd: BsCss.backgroundRepeat("noRepeat"),
        tl: {
          hd: BsCss.backgroundPosition("center"),
          tl: {
            hd: BsCss.position("relative"),
            tl: {
              hd: BsCss.marginLeft("auto"),
              tl: {
                hd: BsCss.marginRight("auto"),
                tl: {
                  hd: BsCss.marginTop(BsCss.px(30)),
                  tl: {
                    hd: BsCss.marginBottom(BsCss.px(30)),
                    tl: {
                      hd: BsCss.media("(max-width: 1199px)", {
                            hd: BsCss.height(BsCss.px(405)),
                            tl: {
                              hd: BsCss.width(BsCss.px(1200)),
                              tl: /* [] */0
                            }
                          }),
                      tl: {
                        hd: BsCss.media("(min-width: 1200px)", {
                              hd: BsCss.width(BsCss.px(1406)),
                              tl: {
                                hd: BsCss.minHeight(BsCss.px(405)),
                                tl: /* [] */0
                              }
                            }),
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var leftLine = Curry._1(BsCss.style, {
      hd: BsCss.display("none"),
      tl: {
        hd: BsCss.media("(min-width: 1200px)", {
              hd: BsCss.display("flex"),
              tl: {
                hd: BsCss.height(BsCss.px(392)),
                tl: {
                  hd: BsCss.width(BsCss.pct(25.0)),
                  tl: {
                    hd: BsCss.backgroundImage(BsCss.url("/images/about/journey/left.svg")),
                    tl: {
                      hd: BsCss.backgroundRepeat("noRepeat"),
                      tl: {
                        hd: BsCss.backgroundPosition("right"),
                        tl: {
                          hd: BsCss.marginTop(BsCss.px(36)),
                          tl: {
                            hd: BsCss.marginRight(BsCss.px(-15)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var rightLine = Curry._1(BsCss.style, {
      hd: BsCss.display("none"),
      tl: {
        hd: BsCss.media("(min-width: 1200px)", {
              hd: BsCss.display("flex"),
              tl: {
                hd: BsCss.height(BsCss.px(392)),
                tl: {
                  hd: BsCss.width(BsCss.pct(30.0)),
                  tl: {
                    hd: BsCss.backgroundImage(BsCss.url("/images/about/journey/right.svg")),
                    tl: {
                      hd: BsCss.backgroundRepeat("noRepeat"),
                      tl: {
                        hd: BsCss.backgroundPosition("left"),
                        tl: {
                          hd: BsCss.marginTop(BsCss.px(35)),
                          tl: {
                            hd: BsCss.marginLeft(BsCss.px(-12)),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var topRowContainer = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1200)),
      tl: {
        hd: BsCss.display("flex"),
        tl: /* [] */0
      }
    });

var bottomRowContainer = Curry._1(BsCss.style, {
      hd: BsCss.maxWidth(BsCss.px(1200)),
      tl: {
        hd: BsCss.display("flex"),
        tl: /* [] */0
      }
    });

var Styles = {
  wrapper: wrapper,
  innerWrapper: innerWrapper,
  headingDiv: headingDiv,
  headingText: headingText,
  swipeRightDiv: swipeRightDiv,
  aboutUsOurJourneyContainer: aboutUsOurJourneyContainer,
  innerContainer: innerContainer,
  leftLine: leftLine,
  rightLine: rightLine,
  topRowContainer: topRowContainer,
  bottomRowContainer: bottomRowContainer
};

function OurJourneySection(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Heading1.make, {
                              children: "Our journey",
                              className: headingText
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                "SWIPE",
                                JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                                      icon: [
                                        "fas",
                                        "arrow-right"
                                      ],
                                      className: "ml-1"
                                    })
                              ],
                              className: swipeRightDiv
                            })
                      ],
                      className: headingDiv
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: leftLine
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(Year2014.make, {}),
                                                    JsxRuntime.jsx(Year2018.make, {}),
                                                    JsxRuntime.jsx(Year2020.make, {})
                                                  ],
                                                  className: topRowContainer
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx(FirstSmartCard.make, {}),
                                                    JsxRuntime.jsx(Year2016.make, {}),
                                                    JsxRuntime.jsx(OneMillion.make, {}),
                                                    JsxRuntime.jsx(Year2024.make, {})
                                                  ],
                                                  className: bottomRowContainer
                                                })
                                          ],
                                          className: innerContainer
                                        }),
                                    className: aboutUsOurJourneyContainer,
                                    id: "aboutUsOurJourneyContainer"
                                  }),
                              className: innerWrapper
                            }),
                        JsxRuntime.jsx("div", {
                              className: rightLine
                            })
                      ],
                      className: wrapper,
                      id: "aboutUsOurJourneyWrapper"
                    })
              ]
            });
}

var make = OurJourneySection;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
